import { HttpError } from 'utils/HttpError';
import { trackError } from 'utils/trackError';

// Types

export type MainStoreErrorState = Error | null | undefined;

type SetErrorAction = {
  type: 'SET_ERROR';
  error: Error;
};

export type MainStoreErrorAction = SetErrorAction;

// Reducer

export function errorReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreErrorState = null,
  action: MainStoreErrorAction
) {
  switch (action.type) {
    case 'SET_ERROR':
      return action.error;

    default:
      return state;
  }
}

// Actions

export const setError = (error: Error, track = true): SetErrorAction => {
  if (track && error instanceof HttpError && error.statusCode !== 404) {
    trackError(error);
  }

  return { type: 'SET_ERROR', error };
};
